export const TranslationTypes = {
  DEFAULT: 'default',
  SHORT: 'short',
  LONG: 'long',
};
/*
String keys that may be specified through customer-config.
These constants should only be changes together with corresponding
changes in customer-config for all places.
 */
export const CustomerConfigTranslatedStringKeyPaths = {
  TOT: 'tot',
};

export const DEFAULT_TRANSLATIONS = {
  [CustomerConfigTranslatedStringKeyPaths.TOT]: {
    [TranslationTypes.DEFAULT]: 'TOT',
    [TranslationTypes.SHORT]: 'TOT',
    [TranslationTypes.LONG]: 'Transient Occupancy Tax',
  },
};
